<template>
	<div class="all-wizard">
		<div class="container-wizards">
			<h2 class="title-wizards" v-if="!estimator">Yes, your project requires Title 24 Compliance</h2>
			<h2 class="title-wizards" v-if="estimator">Select the correct cost estimator</h2>
			<div class="sub-type">
				<div class="label" >
					<div>Type of work to be performed:</div>
				</div>

				<b-form-group label="">
					<b-form-radio-group id="radios2" v-model="selectedSecondRadiosGroup" name="radioSubComponentType">
						<!-- <b-form-radio value="newBuilding"><span>New Building</span></b-form-radio> -->
						<b-form-radio value="existingPlusAdditions"><span>Existing-Plus-Addition</span></b-form-radio>
						<b-form-radio value="newPlusAdditions" ><span>Addition by itself</span></b-form-radio>
					</b-form-radio-group>
				</b-form-group>

				</div>

				<transition name="fade" mode="out-in">
					<!-- <new-building-component v-if='selectedSecondRadiosGroup === "newBuilding"' /> -->
					<existingPlusAdditionsComponent wichComponent='conversion' v-if='whereAreWeSecond("existingPlusAdditions")' />
					<newPlusAdditionsComponent v-if='whereAreWeSecond("newPlusAdditions")' />
				</transition>

		</div>
	</div>
</template>

<script>
import eventBus from '@/commonSite/eventBus.js'
import newBuildingComponent from './newBuildings.vue'
import existingPlusAdditionsComponent from './conversionOrExistingPlusAdditions.vue'
import newPlusAdditionsComponent from './newPlusAdditions.vue'
import LocalStorageService from '@/commonSite/StorageService.js'
export default {
	name: 'all-wizards',
	props: ['estimator'],
	data: function () {
		return {
			navLinks: {},
			selectedSecondRadiosGroup: '',
			activeTypeA: 1
		}
	},
	components: {
		newBuildingComponent,
		existingPlusAdditionsComponent,
		newPlusAdditionsComponent
		// genericResidentialComponent
	},
	beforeMount: function () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
	},
	created () {
		this.getAccordionsValue()
		eventBus.$on('value-accordion-a', () => {
			// console.debug('father has speaked: and say a is closed ')
			this.selectedSecondRadiosGroup = ''
		})
	},
	methods: {
		setSecondState: function (tipo, cssWho) {
			this.selectedSecondRadiosGroup = tipo
			this.activeTypeA = cssWho
		},
		whereAreWeSecond: function (value) {
			// This method detect if select correct option return true
			if (this.selectedSecondRadiosGroup === value) {
				return true
			}
			this.setAccordionState()
		},
		getAccordionsValue () {
			let localStorage = new LocalStorageService()
			this.selectedSecondRadiosGroup = localStorage.findItem('subMenuResidential', true)
		},
		setAccordionState () {
			let localStorage = new LocalStorageService()
			localStorage.setItem('subMenuResidential', this.selectedSecondRadiosGroup, true)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/complianceWizard/residentialWizards/menuResidential.vue